import { firebase } from '@/plugins/firebase';
import moment from 'moment';
import _ from 'lodash';

const functions = firebase.app().functions('asia-northeast1');

export default {
  namespaced: true,
  state: {
    initialized: false,
    customer: {},
    purchaseHistory: []
  },
  mutations: {
    loadCustomer(state, customer) {
      state.customer = customer;
    },
    loadPurchaseHistory(state, payload) {
      // TODO: can't update array
      state.purchaseHistory = payload.purchaseHistory;
    },
    addPaymentMethod(state, card) {
      state.customer.cards.data.unshift(card);
    },
    deletePaymentMethod(state, cardId) {
      const el = _.find(state.customer.cards.data, function (card) {
        return card['id'] == cardId;
      });
      const index = _.indexOf(state.customer.cards.data, el);
      state.customer.cards.data.splice(index, 1);
    }
  },
  actions: {
    async loadCustomer({ commit }, payload) {
      const getCustomerByCustomerId = functions.httpsCallable(
        'paymentGetCustomerByCustomerId'
      );
      let customer = null;
      try {
        customer = await getCustomerByCustomerId({
          customerId: payload.userId
        });
      } catch (err) {
        console.error(err);
      }

      // if customer not exist create one0
      if (!customer) {
        const createCustomer = functions.httpsCallable('paymentCreateCustomer');
        customer = await createCustomer({
          userId: payload.userId,
          email: payload.email
        });
      }
      commit('loadCustomer', customer.data);
    },
    async changeDefaultCard({ state }, usualId) {
      const updateCustomer = functions.httpsCallable('paymentUpdateCustomer');
      await updateCustomer({
        userId: state.customer.id,
        params: { default_card: usualId }
      });
    },
    async loadPurchaseHistory({ commit }, userId) {
      const getChargeListMethod = functions.httpsCallable('paymentGetChargeList');

      try {
        const purchaseHistory = await getChargeListMethod({
          userId: userId
        });
        let history = [];
        for (let data of purchaseHistory.data.data) {
          if (data.captured) {
            history.push(data);
          }
        }
        commit('loadPurchaseHistory', {
          purchaseHistory: history
        });
      } catch (err) {
        console.error(err);
        return;
      }
    },
    async addPaymentMethod({ commit }, payload) {
      const createPaymentFinishMethod = functions.httpsCallable('paymentCreatePaymentFinishMethod');

      const card = await createPaymentFinishMethod({
        userId: payload.userId,
        tokenId: payload.tokenId,
      });
      commit('addPaymentMethod', card.data);
    },
    async deletePaymentMethod({ commit }, payload) {
      const deletePaymentMethod = functions.httpsCallable(
        'paymentDeletePaymentMethod'
      );
      await deletePaymentMethod({
        userId: payload.userId,
        cardId: payload.cardId
      });
      commit('deletePaymentMethod', payload.cardId);
    }
  },
  getters: {
    paymentMethods(state) {
      return Object.keys(state.customer).length == 0
        ? []
        : state.customer.cards.data;
    },
    defaultCardID(state) {
      return Object.keys(state.customer).length == 0
        ? null
        : state.customer.default_card;
    },
    paymentHistory(state) {
      return _.map(state.purchaseHistory, function (purchase) {
        return {
          id: purchase.id,
          activity: 'ドロン',
          datetime: moment.unix(purchase.created),
          price: purchase.amount,
          transactionDetails: {
            product: 'ドロン',
            amount: purchase.amount,
            description: purchase.description,
            paymentMethod: {
              cardBrand: purchase.card.brand,
              lastFourDigits: purchase.card.last4
            }
          }
        };
      });
    }
  }
};
